import i18next, { type i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { environment } from '@/config/environment';
import { readStoredLanguage } from '@/lib/languageStorage';
import { translationResources } from './translationResources';
import { TRANSLATION_NAMESPACE_LIST, DEFAULT_TRANSLATION_NAMESPACE } from './translationNamespaces';
import { FALLBACK_LANGUAGE, isSupportedLanguage } from './supportedLanguages';

function resolveInitialLanguage(): string {
  const storedLanguage = readStoredLanguage();
  if (storedLanguage !== null && isSupportedLanguage(storedLanguage)) {
    return storedLanguage;
  }
  if (isSupportedLanguage(environment.defaultLocale)) {
    return environment.defaultLocale;
  }
  return FALLBACK_LANGUAGE;
}

export function initializeI18n(): I18nInstance {
  i18next.use(initReactI18next).init({
    resources: translationResources,
    lng: resolveInitialLanguage(),
    fallbackLng: FALLBACK_LANGUAGE,
    ns: TRANSLATION_NAMESPACE_LIST,
    defaultNS: DEFAULT_TRANSLATION_NAMESPACE,
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        brandName: environment.brandName,
      },
    },
    returnNull: false,
  });

  return i18next;
}
